export default {"src":"/_next/static/media/icon-menu.e7cf586b.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};